import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/faqs';
import { siteConfig } from '../../data/config';
import { useEditorPreview } from '../../contexts/EditorContext';
import { Pending } from '../Pending';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  const editor = useEditorPreview();
  return <section className="bg-white px-5 pb-8 pt-2" data-id="element-30" data-mp="71glo3wh4lfj">
      <div className="mx-auto max-w-[520px]" data-id="element-31" data-mp="22x0i5ppfdo8">
        <h2 className="text-center font-display text-[21px] uppercase leading-none text-navy md:text-[24px]" data-id="element-32" data-mp="23yfgl9uckb8">Frequently asked questions</h2>
        <ul className="mt-4 space-y-2" data-id="element-33" data-mp="bzry8me5la1g">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const configured = f.pendingKey ? siteConfig[f.pendingKey] : '';
          const answer = f.pendingKey ? configured || 'Full details are shown on the checkout page.' : f.answer;
          return <li key={f.question} className="rounded-[3px] border border-line bg-white" data-id="element-34" data-mp="hsxst1pujksp" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left font-display text-[10.5px] uppercase tracking-[0.02em] text-navy transition-colors duration-150 ease-out hover:bg-paper focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-35" data-mp="mrr8n0slvnw1">
                  {f.question}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-36" data-mp="81tf05bwq5zg" />
                </button>
                <AnimatePresence initial={false} data-id="element-37" data-mp="3gj7sshjxtei2">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-38" data-mp="nozgp8nke8xm">
                      <p className="px-3 pb-2.5 text-[11px] leading-[1.6] text-muted" data-id="element-39" data-mp="4q4z7rwpuudr">
                        {answer}
                        {f.pendingKey && !configured && editor && <span className="ml-2" data-id="element-40" data-mp="dr374la9zm1m">
                            <Pending label={f.pendingKey === 'deliveryDetails' ? 'Delivery details' : 'Payment & refund terms'} data-id="element-41" data-mp="drupuvirxpah" />
                          </span>}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}